var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-404"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"w-500 title"},[_vm._t("title")],2),_c('div',{staticClass:"s-20 w-400"},[_vm._t("subtitle")],2),_c('div',{staticClass:"button-wrapper"},[_vm._t("button")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }